import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "./FirebaseConfig";

// Fire a GA4 page_view on every SPA route change. Firebase Analytics already
// sends the initial page_view automatically when it initializes, so we skip the
// first render here to avoid double-counting that first page, then log manually
// on each subsequent navigation. `analytics` is set asynchronously (after
// isSupported() resolves) — ES module live bindings mean this import always
// reflects the latest value, and the guard below no-ops until it's ready.
// Renders nothing.
export default function AnalyticsTracker() {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (!analytics) return;
    logEvent(analytics, "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
